<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.toolMagazine.form.specOption')" prop="specOptionId">
        <a-select
          v-model="form.specOptionId"
          allow-clear
          show-search
          :placeholder="$t('views.toolMagazine.form.specOptionPlaceholder')"
          :loading="specOptionLoading"
          option-filter-prop="_label"
          option-label-prop="_label"
          :filter-option="filterSpecOptionOption"
          style="width: 100%"
          :getPopupContainer="trigger => trigger.parentNode"
          @dropdownVisibleChange="onSpecOptionDropdownVisible"
        >
          <a-select-option
            v-for="opt in specOptionOptions"
            :key="opt.id"
            :value="String(opt.id)"
            :_label="opt.name"
          >
            {{ opt.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="名称(英文)" prop="nameEn" >
        <a-input v-model="form.nameEn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.toolMagazine.form.width')" prop="width">
        <a-input-number
          v-model="form.width"
          :min="0"
          :step="0.01"
          :precision="2"
          allow-clear
          style="width: 100%"
          :placeholder="$t('views.toolMagazine.form.widthPlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.toolMagazine.form.height')" prop="height">
        <a-input-number
          v-model="form.height"
          :min="0"
          :step="0.01"
          :precision="2"
          allow-clear
          style="width: 100%"
          :placeholder="$t('views.toolMagazine.form.heightPlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.toolMagazine.form.borderDefense')" prop="borderDefense">
        <a-input-number
          v-model="form.borderDefense"
          :min="0"
          :step="0.01"
          :precision="2"
          allow-clear
          style="width: 100%"
          :placeholder="$t('views.toolMagazine.form.borderDefensePlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.toolMagazine.form.quantity')" prop="quantity">
        <a-input-number
          v-model="form.quantity"
          :min="0"
          :step="1"
          :precision="0"
          allow-clear
          style="width: 100%"
          :placeholder="$t('views.toolMagazine.form.quantityPlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item label="制作时间" prop="productionTime" >
        <a-date-picker style="width: 100%" v-model="form.productionTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getToolMagazine, addToolMagazine, updateToolMagazine } from '@/api/user/toolMagazine'
import { listSpecOption } from '@/api/user/specOption'

/** 刀模杂志表单：规格选项列表固定按该规格筛选（与 listSpecOption 查询参数一致） */
const TOOL_MAGAZINE_SPEC_ID = '647457401989140481'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        specOptionId: null,

        name: null,

        nameEn: null,

        width: null,

        height: null,

        borderDefense: null,

        quantity: null,

        productionTime: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      },
      specOptionOptions: [],
      specOptionLoading: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.specOptionOptions = []
      this.formType = 1
      this.form = {
        id: null,
        specOptionId: null,
        name: null,
        nameEn: null,
        width: null,
        height: null,
        borderDefense: null,
        quantity: null,
        productionTime: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
    },
    loadSpecOptionOptions () {
      if (this.specOptionLoading) {
        return
      }
      this.specOptionLoading = true
      listSpecOption({ specId: TOOL_MAGAZINE_SPEC_ID, parentId: 0 }).then(res => {
        const data = (res && res.data) || []
        this.specOptionOptions = Array.isArray(data) ? data : []
      }).finally(() => {
        this.specOptionLoading = false
      })
    },
    onSpecOptionDropdownVisible (open) {
      if (open && !this.specOptionOptions.length && !this.specOptionLoading) {
        this.loadSpecOptionOptions()
      }
    },
    normalizeNumericFormFields () {
      ;['width', 'height', 'borderDefense', 'quantity'].forEach(key => {
        const v = this.form[key]
        if (v === null || v === undefined || v === '') {
          this.form[key] = null
          return
        }
        const n = Number(v)
        this.form[key] = Number.isFinite(n) ? n : null
      })
    },
    filterSpecOptionOption (input, option) {
      const text =
        option &&
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      return (text || '').toLowerCase().includes((input || '').toLowerCase())
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.loadSpecOptionOptions()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getToolMagazine({"id":id}).then(response => {
        this.form = response.data
        if (this.form.specOptionId != null && this.form.specOptionId !== '') {
          this.form.specOptionId = String(this.form.specOptionId)
        }
        this.normalizeNumericFormFields()
        this.open = true
        this.formTitle = '修改'
        this.loadSpecOptionOptions()
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateToolMagazine(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addToolMagazine(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
